import type { Store, ThunkDispatch, UnknownAction } from '@reduxjs/toolkit';

import asyncDispatchMiddleware from './asyncDispatchMiddleware';
import * as immutableSerialize from './immutableSerialize';
import type RootState from './rootState';

export * from './crashReporterMiddleware';
export * from './sagaMiddleware';

// The real store instance (injected later)
let gStore: Store<RootState> | null = null;

// Correct dispatch type (does not depend on gStore being non-null)
export type AppDispatch = ThunkDispatch<RootState, unknown, UnknownAction>;

export const inject = (newStore: Store<RootState>) => {
  gStore = newStore;
};

export { asyncDispatchMiddleware, gStore as default, immutableSerialize };
